import { httpGet, httpPost } from "@eres/rest";
import { I8N, StringUtil } from "@eres/core";
import { TabuRequestApi } from "@10x/tabu-mobile-api";
import cfg from "./config";
import { ProcedureDoc, ProcedureTransaction, ValidationError } from "./entities";

export function loadProcedureCategories( tabuPropertyId: number, userId: number ) {
	return httpGet( cfg.rtRegAPI().endPoint() + `Procedures/configuration/${ tabuPropertyId }/${ userId }` ).then( r => {
		return validateResponse( r );
	} );
}

export function loadProcedures( tabuPropertyId: number, categoryId: number, userId: number ) {
	return httpGet( cfg.rtRegAPI().endPoint() + `Procedures/configuration/${ tabuPropertyId }/${ categoryId }/${ userId }` ).then( r => {
		return validateResponse( r );
	} );
}

export function loadRTOffices() {
	return httpGet( cfg.rtRegAPI().endPoint() + "Procedures/GetAllRtOffices" ).then( r => {
		return validateResponse( r );
	} );
}

export function initProcedure( tabuPropertyId: number, procedureId: number, userId: number ) {
	return httpGet( cfg.rtRegAPI().endPoint() + `Procedures/init/${ tabuPropertyId }/${ procedureId }/${ userId }` ).then( r => {
		return validateResponse( r );
	} );
}

export function saveProcedureTransaction( userId: number, procedure: ProcedureTransaction ) {
	return httpPost( cfg.rtRegAPI().endPoint() + `Procedures/${ userId }`, procedure ).then( r => {
		return validateResponse( r );
	} );
}

export function loadRTRequests( userId: number ) {
	return httpGet( cfg.rtRegAPI().endPoint() + `Procedures/Enquiry/${ userId }/${ userId }` ).then( r => {
		return validateResponse( r );
	} );
}

export function cancelRTRequest( procedureId: number, procedureYear: number, procedureNumber: number,
                                 onlineRequestId: number, operatingUserId: number ) {
	return httpPost( cfg.rtRegAPI().endPoint() + `Procedures/CancelProcedure/${ procedureId }/
    ${ procedureYear }/${ procedureNumber }/${ onlineRequestId }/${ operatingUserId }`, undefined ).then( r => {
		return validateResponse( r );
	} );
}

function validateResponse<T>( response: any ): Promise<T> {
	if ( response == undefined ) {
		return Promise.reject( "Empty response" );
	} else if ( response.Errors && response.Errors.length > 0 ) {
		let reason = getValidationError( response.Errors );
		return Promise.reject( reason );
	}
	return Promise.resolve( response.ResponseEntity );
}

export function getValidationError( errors: ValidationError[] ) {
	let errorMsg = errors.map( ( error: ValidationError ) => {
		let nameEn = !StringUtil.isEmptyStringOrNull( error.ErrorMessage ) ? error.ErrorMessage :
			error.ErrorMessageAr;
		let nameAr = !StringUtil.isEmptyStringOrNull( error.ErrorMessageAr ) ? error.ErrorMessageAr : nameEn;
		return I8N.isRTL() ? nameAr : nameEn;
	} );
	return errorMsg.join( "\n" );
}

export function uploadDocuments( docs: ProcedureDoc[] ): Promise<any> {
	let uploadTasks: Promise<any>[] = [];
	for ( const procedureDoc of docs ) {
		if ( procedureDoc.Path && !StringUtil.isEmptyStringOrNull( procedureDoc.Path ) ) {
			uploadTasks.push( Promise.resolve( procedureDoc ) );
		} else {
			if ( procedureDoc.doc && procedureDoc.doc.localData ) {
				const localData = procedureDoc.doc.localData;
				const extData = localData.split( ";" )[ 0 ];
				const type = extData.includes( "image" ) ? "jpg" : "pdf";
				let encoded = localData.replace( /^data:(.*;base64,)?/, "" );
				if ( ( encoded.length % 4 ) > 0 ) {
					encoded += "=".repeat( 4 - ( encoded.length % 4 ) );
				}
				uploadTasks.push( TabuRequestApi.uploadTabuDocument( encoded, type ).then( ( response ) => {
						procedureDoc.doc!.fileName = response.Response.FileName;
						procedureDoc.Path = response.Response.DocumentPath;
						return Promise.resolve( procedureDoc );
					} ).catch( ( reason ) => {
						return Promise.reject( reason );
					} )
				);
			} else {
				uploadTasks.push( Promise.resolve( procedureDoc ) );
			}
		}
	}
	return Promise.all( uploadTasks );
}
